module.exports = __webpack_public_path__ + "img/gb9123_30_c.prt.38a4648a.jpg";